module.exports = __webpack_public_path__ + "static/media/white-gold-abstract.107ab1eb.jpg";